const paymentMethods = {
  afterpay: true,
  gem: true,
};

// Function to get the variant ID from the URL
function getVariantFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('variant');
}

// Detect changes to the variant parameter in the URL
setInterval(() => {
  const currentVariant = getVariantFromURL();
  if (currentVariant !== window.previousVariantId) {
    window.previousVariantId = currentVariant;
    updatePaymentOptionAmounts();
  }
}, 1000);

function getAmountForCurrentVariant(currentVariantId) {
  const variantIdRefElement = document.querySelector(
    `span[data-variantidref="${currentVariantId}"]`
  );
  if (variantIdRefElement) {
    const rawAmount = Number(variantIdRefElement.innerHTML);
    const updatedAmount = (rawAmount / 4 / 100).toFixed(2);
    return `$${updatedAmount}`;
  }
}


function togglePaymentMethods(currentVariantId) {
  const variantIdRefElement = document.querySelector(
    `span[data-variantidref="${currentVariantId}"]`
  );

  if (variantIdRefElement) {
    const rawAmount = Number(variantIdRefElement.innerHTML);
    const moneyAmount = (rawAmount / 100).toFixed(2);
    if (moneyAmount < 1 || moneyAmount > 3000) {
      paymentMethods.afterpay = false;
    } else {
      paymentMethods.afterpay = true;
    }

    if (moneyAmount < 999 || moneyAmount > 30000) {
      paymentMethods.gem = false;
    } else {
      paymentMethods.gem = true;
    }
  }
}

function updatePaymentOptionAmounts() {
  const selectedVariantId = getVariantFromURL();

  if (selectedVariantId) {
    togglePaymentMethods(selectedVariantId);
    
    const dataVariantId = document.querySelector('[data-variantid]');

    dataVariantId.setAttribute('data-variantid', selectedVariantId);

    const paymentOptions = document.querySelector('.instant-finance-new');
    const gem = paymentOptions.querySelector(
      '.payment-option[data-option="gem"]'
    );
    const afterpay = paymentOptions.querySelector(
      '.payment-option[data-option="afterpay"]'
    );

    const paymentOptionsHeader = document.querySelector('.payments-header');
    const gemHeader = paymentOptionsHeader.querySelector(
      'img.gem-qcard'
    );
    const afterpayHeader = paymentOptionsHeader.querySelector(
      'img.afterpay'
    );

    if (gemHeader) {
      if (!paymentMethods.gem) {
        if (!gemHeader.classList.contains('hide')) {
          gemHeader.classList.add('hide');
        }
      } else {
        if (gemHeader.classList.contains('hide')) {
          gemHeader.classList.remove('hide');
        }
      }
    }

    if (gem) {
      if (!paymentMethods.gem) {
        if (!gem.classList.contains('hide')) {
          gem.classList.add('hide');
        }
      } else {
        if (gem.classList.contains('hide')) {
          gem.classList.remove('hide');
        }
      }
    }

    if (afterpayHeader) {
      if (!paymentMethods.afterpay) {
        if (!afterpayHeader.classList.contains('hide')) {
          afterpayHeader.classList.add('hide');
        }
      } else {
        if (afterpayHeader.classList.contains('hide')) {
          afterpayHeader.classList.remove('hide');
        }
      }
    }

    if (afterpay) {
      if (!paymentMethods.afterpay) {
        if (!afterpay.classList.contains('hide')) {
          afterpay.classList.add('hide');
        }
      } else {
        if (afterpay.classList.contains('hide')) {
          afterpay.classList.remove('hide');
        }
      }
      const amount = afterpay.querySelector('.BNPL-amount');
      const newAmount = getAmountForCurrentVariant(selectedVariantId);
      if (newAmount) {
        amount.innerHTML = newAmount;
      }
    }
  }
}
